import { css, keyframes } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';

const AnimationWithCalc = keyframes({
  '0%': {
    transform: 'translateY(calc(100% + 10px))',
  },
  '100%': {
    transform: 'translateY(calc(60% + 10px))',
  },
});

const AnimationTranslation = keyframes({
  '0%': {
    transform: 'translateY(0%)',
  },
  '100%': {
    transform: 'translateY(-40%)',
  },
});

const Animation = {
  fullHero: [AnimationWithCalc, AnimationTranslation],
  basicHero: [AnimationTranslation, AnimationTranslation],
};

export const ArrowDownStyles = type =>
  css({
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: colorsPalette.white,
    position: 'absolute',
    bottom: 0,
    right: 0,
    display: 'none',
    animation: `${Animation[type][0]} 1s ease-in infinite alternate`,
    [MediaQueries.mdAndUp]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    [MediaQueries.lgAndUp]: {
      animation: `${Animation[type][1]} 1s ease-in infinite alternate`,
    },
  });
